const pdfDimensions = [
    {

    },
    // RL
    // 1
    {
        english: {
            count: 14,
            width: 300
        },
        arabic: {
            count: 14,
            width: 300
        }
    },
    {
        english: {
            count: 18,
            width: 225
        },
        arabic: {
            count: 14,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 18,
            width: 474
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 18,
            width: 474
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    // LR
    // 7
    {
        english: {
            count: 14,
            width: 300
        },
        arabic: {
            count: 14,
            width: 300
        }
    },
    {
        arabic: {
            count: 18,
            width: 225
        },
        english: {
            count: 14,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        arabic: {
            count: 18,
            width: 474
        },
        english: {
            count: 30,
            width: 300
        }
    },
    {
        arabic: {
            count: 18,
            width: 474
        },
        english: {
            count: 30,
            width: 300
        }
    },
    // RLLR
    // 13
    {
        english: {
            count: 14,
            width: 300
        },
        arabic: {
            count: 14,
            width: 300
        }
    },
    {
        english: {
            count: 18,
            width: 225
        },
        arabic: {
            count: 14,
            width: 300
        }
    },
    {
        arabic: {
            count: 18,
            width: 225
        },
        english: {
            count: 14,
            width: 300
        }
    },
    {
        english: {
            count: 14,
            width: 300
        },
        arabic: {
            count: 14,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 18,
            width: 474
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        arabic: {
            count: 18,
            width: 474
        },
        english: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    {
        english: {
            count: 30,
            width: 300
        },
        arabic: {
            count: 30,
            width: 300
        }
    },
    // V
    // 26
    {
        english: {
            count: 19,
            width: 222
        },
        arabic: {
            count: 19,
            width: 222
        }
    },
    {
        english: {
            count: 19,
            width: 222
        },
        arabic: {
            count: 19,
            width: 222
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },
    {
        english: {
            count: 19,
            width: 474
        },
        arabic: {
            count: 19,
            width: 474
        }
    },

]

export default pdfDimensions;